import { useCookies } from 'react-cookie';

interface UseBanner {
  bannerVisible: boolean;
  bannerClose: () => void;
}

export const useBanner = (): UseBanner => {
  const [cookies, setCookies] = useCookies(['banner']);

  const bannerClose = () => {
    setCookies('banner', false, {
      maxAge: 86400,
      path: '/',
      sameSite: 'strict',
    });
  };

  return {
    bannerVisible:
      !Object.prototype.hasOwnProperty.call(cookies, 'banner') ||
      (cookies.banner &&
        (cookies.banner === 'true' || cookies.banner === true)),
    bannerClose,
  };
};
